<script>
	import { onMount, getContext, onDestroy } from 'svelte'
	import * as animateScroll from 'svelte-scrollto'
	import {
		adminUpdateFoodsEntry,
		SingleItem,
		adminFoodsCategory,
		sort_array,
		change_menuorder,
		remove_duplicates,
	} from '../AdminModule.svelte'
	import { slide } from 'svelte/transition'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import { styles } from '../../../library/scripts/styles'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')
	const fsX = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const color = globals.colorMain
	const colorError = globals.colorError
	const shadow = globals.boxShadow
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover
	const iconSmall = globals.iconSmall

	let menu = []
	let categories = []

	//show single item
	let showItem = false
	let itemID = null

	let alertError = false
	let message = ''

	const delete_item_from_db = async (id) => {
		const deleteItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'delete_menu_entry',
				dbtable: 'foods',
				data: {
					id: id,
				},
			}),
		})

		showItem = false
		const dataResponse = await deleteItem.json()
		adminFoodsCategory.set(dataResponse.categs)
		return dataResponse.fetch
	}

	const show_item = (id) => {
		animateScroll.scrollToTop()
		showItem = true
		itemID = id
	}

	const close_item = () => {
		showItem = false
	}

	const reset_error = () => {
		alertError = false
		message = ''
	}

	const delete_item = (id) => {
		const deleteFromDb = delete_item_from_db(id)
		if (deleteFromDb) {
			const menu = JSON.parse(sessionStorage.getItem('foods'))

			// get the menuorder from deleted item
			let delNumber
			let updateMenu = true

			const newMenu = menu.filter((item) => {
				if (item.id === id) delNumber = item.menuorder
				if (item.id != id) return item
			})

			// check if an item with this menuorder still exists
			newMenu.forEach((e) => {
				if (e.menuorder === delNumber) updateMenu = false
			})

			// if it not exists we have to update the menuorder
			if (updateMenu) {
				newMenu.forEach((e) => {
					if (e.menuorder > delNumber) e.menuorder = e.menuorder - 1
				})
			}

			adminUpdateFoodsEntry.set(JSON.stringify(newMenu))
			sessionStorage.setItem('foods', JSON.stringify(newMenu))
		}
	}

	const alterate_item = (item) => {
		let oldMenu = sessionStorage.getItem('foods')
		oldMenu = JSON.parse(oldMenu)
		oldMenu.forEach((om) => {
			if (om.id === item.id) {
				SingleItem.set(
					item.category +
						'~' +
						item.id +
						'~' +
						item.name +
						'~' +
						item.description +
						'~' +
						item.price +
						'~' +
						item.currency
				)
			}
		})
	}

	const change_order = async (e) => {
		const newOrder = await change_menuorder(e, 'foods')
		categories = remove_duplicates(newOrder)
		categories = sort_array(categories)
		adminFoodsCategory.set(categories)

		// update the menu-order in session storage
		const menu = JSON.parse(sessionStorage.getItem('foods'))

		categories.forEach((cat) => {
			menu.forEach((men) => {
				if (cat[0] === men.category) men.menuorder = cat[1]
			})
		})

		sessionStorage.setItem('foods', JSON.stringify(menu))
		adminUpdateFoodsEntry.set(JSON.stringify(menu))
	}

	// remove duplicates from categories
	$: categories = remove_duplicates(categories)
	$: categories = sort_array(categories)
	$: adminFoodsCategory.set(categories)

	onMount(async () => {
		adminUpdateFoodsEntry.subscribe((value) => {
			menu = JSON.parse(value)
			//reset categories
			if (menu != null) {
				categories.length = 0
				menu.forEach((item) => {
					categories.push([item.category, item.menuorder])
				})
			}
		})

		categories = remove_duplicates(categories)
		categories = sort_array(categories)
		adminFoodsCategory.set(categories)
	})

	onDestroy(() => {
		SingleItem.set(false)
	})
</script>

<div class="container">
	{#if !showItem}
		<div style="width:100%" transition:slide={{ duration: 500, delay: 600 }}>
			<div class="title" use:styles={{ fsX, color }}>MENU FOODS PREVIEW</div>
			<!-- no entry yet -->

			{#if menu === null || menu.length === 0}
				<div class="message error" use:styles={{ fsN, colorError }}>No entry yet</div>
			{:else}
				{#each categories as category}
					<div class="category" use:styles={{ fsN, color }}>
						{#if category[1] < categories.length}
							<div
								class="arrow"
								arrow-down
								use:styles={{ iconSmall }}
								on:click={() => change_order(category[0])}
								on:keydown={() => change_order(category[0])}
							/>
						{:else}
							<div />
						{/if}
						<div>{category[0]}</div>
					</div>

					{#each menu as item}
						{#if item.category === category[0]}
							<div class="item_grid" use:styles={{ fsN, color }}>
								<div />
								<div>{item.name}</div>
								<div class="align_right">{item.currency}</div>
								<div class="align_right">{item.price}</div>
								<div class="show_item" on:click={() => show_item(item.id)} on:keydown={() => show_item(item.id)} />
								<div class="link" on:click={() => delete_item(item.id)} on:keydown={() => delete_item(item.id)} />
							</div>
						{/if}
					{/each}
					<div class="spacer" />
				{/each}
			{/if}
		</div>
	{/if}

	{#if showItem}
		<div id="singleItem" style="width:100%;" transition:slide={{ duration: 500, delay: 600 }}>
			{#each menu as item}
				{#if itemID === item.id}
					<div class="single_item_menu_bar">
						<div class="title" use:styles={{ fsX, color }}>{item.name}</div>
					</div>
					<div class="item_row" use:styles={{ fsN, color }}>
						<div>category</div>
						<div>{item.category}</div>
						<div>description</div>
						<div>{item.description}</div>
						<div>price</div>
						<div>{item.currency} {item.price}</div>
					</div>
					<div class="button_container">
						<button use:styles={{ fsS, shadow, buttonHover, buttonColor }} on:click={() => alterate_item(item)}
							>amend</button
						>
						<button use:styles={{ fsS, shadow, buttonHover, buttonColor }} on:click={() => delete_item(item.id)}
							>delete</button
						>
						<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click={close_item}>close</button>
					</div>
				{/if}
			{/each}
		</div>
	{/if}
</div>

{#if alertError}
	<Shader>
		<div slot="content">
			<Alert {message} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

<style>
	button {
		width: 20%;
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: flex-end;
		margin-right: 0%;
		border-radius: 5px;
		font-size: var(--fsS);
		color: var(--buttonColor);
		box-shadow: 3px 3px 3px var(--shadow);
		background-color: transparent;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.button_container {
		margin-top: 30px;
	}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		margin-left: 5%;
		width: 100%;
		cursor: default;
		user-select: none;
	}
	.title {
		font-size: var(--fsX);
		font-weight: bold;
		color: var(--color);
		margin: 30px 0 20px 0;
	}
	.category {
		display: grid;
		grid-template-columns: 6% 94%;
		font-size: var(--fsN);
		color: var(--color);
		font-weight: bold;
		margin-bottom: 1%;
		cursor: default;
		user-select: none;
	}

	.arrow {
		width: var(--iconSmall);
		height: var(--iconSmall);
		border: solid darkslategrey;
		border-width: 0px 5px 5px 0px;
		display: inline-block;
		cursor: pointer;
	}

	.arrow:hover {
		border: solid darkgrey;
		border-width: 0px 5px 5px 0px;
	}

	[arrow-down] {
		transform: rotate(45deg);
		-webkit-transorm: rotate(45deg);
	}

	.item_grid {
		display: grid;
		width: 90%;
		grid-template-columns: 5% 50% 10% 10% 5% 5%;
		font-size: var(--fsN);
		grid-gap: 2%;
		color: var(--color);
		cursor: default;
		user-select: none;
	}

	.item_grid:hover {
		background-color: hsl(0, 0%, 20%);
	}

	.single_item_menu_bar {
		display: flex;
		width: 85%;
		align-items: center;
		justify-content: space-between;
	}

	.item_row {
		width: 95%;
		display: grid;
		grid-template-columns: 25% 75%;
		color: var(--color);
		font-size: var(--fsN);
		grid-row-gap: 30px;
	}

	.link,
	.show_item {
		cursor: pointer;
		width: 25px;
		height: 25px;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.link {
		background-image: url('/images/bin.png');
	}
	.show_item {
		background-image: url('/images/icon_eye.png');
	}

	.align_right {
		justify-self: end;
	}

	.spacer {
		min-height: 1.5vh;
	}

	.message {
		font-size: var(--fsN);
	}

	.error {
		color: var(--colorError);
	}
</style>
